import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { AssetCount } from 'models'
import { StatCardWrapper, StatSkeletonBar } from './statCard.styles'

const NO_DATA = '--'

interface Props {
  title: string
  icon: JSX.Element
  count: AssetCount | null
  loading: boolean
}

const EntityCountCard: FC<Props> = ({ title, icon, count, loading }) => (
  <StatCardWrapper>
    <Box className="stat-header">
      <Box className="stat-heading">
        <Box className="stat-icon">{icon}</Box>
        <Typography className="stat-title">{title}</Typography>
      </Box>
    </Box>
    <Box className="stat-body">
      {loading || !count ? (
        <StatSkeletonBar />
      ) : (
        <>
          <Typography component="span" className="stat-value">
            {count.total.toLocaleString()}
          </Typography>
          <Typography component="span" className="stat-sublabel">
            {/* Null when nothing comparable sits a month back; marked as no data, as elsewhere. */}
            {count.changeSinceLastMonth === null ? (
              `${NO_DATA} `
            ) : (
              <span
                className={
                  count.changeSinceLastMonth > 0 ? 'delta-up' : count.changeSinceLastMonth < 0 ? 'delta-down' : ''
                }
              >
                {count.changeSinceLastMonth > 0 ? '+' : ''}
                {count.changeSinceLastMonth.toLocaleString()}{' '}
              </span>
            )}
            since last month
          </Typography>
        </>
      )}
    </Box>
  </StatCardWrapper>
)

export default EntityCountCard
